import { API_CONFIG, getEnvVar } from './env';

const numberWithCommas = (x) => {
  return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : x;
}

const Data = {
  API_URL: API_CONFIG.BASE_URL,
  FEE_ADDRESS: getEnvVar('FEE_ADDRESS', '0x145d75E48Fa73e29C79FbDC17103cE4891596C61'),
  start_date_for_deal_para: 1644555461953,
  start_date_for_tokenomics: 1659294674853
}

export default {
  numberWithCommas, 
  Data
}